"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfCharacterStyleImporter = void 0;
var tslib_1 = require("tslib");
var character_properties_1 = require("../../../../core/model/character/character-properties");
var character_style_1 = require("../../../../core/model/character/character-style");
var base_style_importer_1 = require("./base-style-importer");
var styles_manager_1 = require("../../../../core/model/styles-manager");
var RtfCharacterStyleImporter = (function (_super) {
    tslib_1.__extends(RtfCharacterStyleImporter, _super);
    function RtfCharacterStyleImporter(data) {
        return _super.call(this, data, true) || this;
    }
    Object.defineProperty(RtfCharacterStyleImporter.prototype, "styleCollection", {
        get: function () { return this.data.documentModel.characterStyles; },
        enumerable: false,
        configurable: true
    });
    ;
    RtfCharacterStyleImporter.prototype.addStyle = function (style) {
        var result = this.documentModel.stylesManager.addCharacterStyle(style);
        result.localizedName = styles_manager_1.StylesManager.getPresetCharacterStyleLocalizedName(style.styleName);
        return result;
    };
    RtfCharacterStyleImporter.prototype.createEmpty = function () {
        return new character_style_1.CharacterStyle('', '', false, false, false, false, new character_properties_1.MaskedCharacterProperties(), '');
    };
    return RtfCharacterStyleImporter;
}(base_style_importer_1.RtfBaseStyleImporter));
exports.RtfCharacterStyleImporter = RtfCharacterStyleImporter;
